
import { Downloadmodal } from "../CommonModal"
import { useEffect, useState } from "react";
import { getStatement } from "../Services/funds.services";

const ExportStatment = () => {

  const [confirm, setConfirm] = useState(false);
  const [url, setUrl] = useState("");
  const [disable, setDisable] = useState(false);
  const [modalBody, setModalBody] = useState("");
  const toggle = () => setConfirm(!confirm);

  useEffect(()=> {
    setConfirm(true);
    handleDownload();

  },[])

  const handleDownload = () =>{
    setModalBody("Votre document est en cours de téléchargement");
    setConfirm(true);
    getStatement().then((result) => {
          setModalBody(result.message);
          console.log(result)
          if (result.code === 0){
            setDisable(false)
            setUrl(result.path)
          }
        });
  }

    return(
        <Downloadmodal isOpen={confirm} 
                       toggler={toggle} 
                       title={`Téléchargment des états financiers`}
                       url={url}
                       disabled= {disable}
                       message={modalBody}/>
    )
}

export default ExportStatment;